module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_resort_sola@3x-a474811b07c7895f9d248a20582a5c46.webp";